import React from 'react';
import { useTranslation } from 'react-i18next';
import { CONTACT_EMAIL, useDocumentTitle } from './links';

/**
 * Sicherheit / Security (concept §6). Only facts verified in the code on
 * 2026-10-19 are printed:
 *   encryption — user-data-broker/src/services/encryption.py (AES-256-GCM, Vault-derived DEK per tenant)
 *   separation — user-data-broker RLS (RDS + row-level security)
 *   login      — LoginPage.tsx (SMS or email one-time code) + PasskeyRegister
 *   deletion   — SettingsPage.tsx handleDeleteAccount
 *
 * TODO(verify) before any of these is printed (concept D7, D8):
 *   - hosting region: Terraform pins eu-central-1; confirm in the live AWS account
 *   - "your data is not used to train models": check every model provider in use, not only Bedrock/Anthropic
 *   - "email content is never written to logs": Message-IDs ARE logged (SECURITY_ARCHITECTURE.md), wording needed
 *   - data export on request, and what exactly happens on deletion
 *   - AVV available for every customer (legal)
 *   - sub-processor list (AWS incl. SES, Twilio, Google, Brevo, the model provider)
 */
const ITEMS = ['hosting', 'encryption', 'separation', 'login', 'deletion'] as const;

const SecurityV2Page: React.FC = () => {
  const { t } = useTranslation();
  useDocumentTitle(t('homeV2.security.meta.title'));

  return (
    <div className="hv2-page">
      <header className="hv2-page__header">
        <h1>{t('homeV2.security.title')}</h1>
        <p className="hv2-page__lead">{t('homeV2.security.lead')}</p>
      </header>
      <div className="hv2-facts">
        {ITEMS.map((key) => (
          <section className="hv2-fact" key={key}>
            <h2>{t(`homeV2.security.items.${key}.title`)}</h2>
            <p>{t(`homeV2.security.items.${key}.body`)}</p>
          </section>
        ))}
      </div>
      <section className="hv2-page__section">
        <h2>{t('homeV2.security.contactTitle')}</h2>
        <p>
          {t('homeV2.security.contact')} <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
        </p>
      </section>
    </div>
  );
};

export default SecurityV2Page;
